import {toastr} from 'react-redux-toastr';
import {
  initialize
} from 'redux-form';
import {
  navigateTo,
  getJsonAsync,
  putJsonAsync
} from 'shared/actions';
import {loadTournament} from '../actions';

export const retrieveRestriction = tournamentId => dispatch => {
  dispatch(getJsonAsync(`setup/tournament/${tournamentId}/restriction`))
  .then(data => dispatch(initialize(`tournamentRestrictions`, data)));
};

export const validate = (data) => {
  const errors = {};

  if (data.enforceMinimumCaptainAge && !data.minimumCaptainAge) {
    errors.minimumCaptainAge = 'Minimum Captain Age is required if "Enforce a minimum captain age" is checked.';
  }

  return errors;
};

export const handleSave = data => (dispatch, getState) => new Promise((resolve) => {
  const tournamentState = getState().tournament,
    tournamentId = tournamentState.base.tournamentInfo.id;

  const promise = putJsonAsync(`setup/tournament/${tournamentId}/restriction`, data);

  dispatch(promise)
    .then(() => {
      toastr.success('Saved!', 'Restrictions saved successfully.');
      dispatch(loadTournament(tournamentId));
      resolve();
    })
    .catch(() => resolve());
});

export const handleCancel = () => dispatch => dispatch(navigateTo('tournament'));




// WEBPACK FOOTER //
// ./src/features/tournament/restrictions/actions.js